var _excluded = ["view", "id", "display", "args", "filters", "className"],
  _excluded2 = ["withProvider", "storageType", "pageQueryParam"];
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Map, List } from 'immutable';
import { viewGet, viewGetLoaded, VIEW_ACTION_APPEND, VIEW_ACTION_REPLACE } from '../../../redux/actions/Entity/View';
import EntityMapperContext from '../../../Context/EntityMapperContext';
import ViewFilterQueryProvider from '../../../Components/ViewFilterQueryProvider';
import useViewFilterQuery from '../../../helpers/useViewFilterQuery';
var View = /*#__PURE__*/function (_Component) {
  _inherits(View, _Component);
  var _super = _createSuper(View);
  function View(props) {
    var _this;
    _classCallCheck(this, View);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "onLoadMore", function (action) {
      var _this$props = _this.props,
        view = _this$props.view,
        id = _this$props.id,
        display = _this$props.display,
        args = _this$props.args,
        filters = _this$props.filters;
      var page = view.getIn(['pager', 'current_page']);
      _this.props.dispatch(viewGet(id, display, page + 1, args, filters, VIEW_ACTION_APPEND, false));
      _this.setState({
        loading: true,
        loadingStartedAt: new Date()
      });
    });
    _this.timeouts = [];
    _this.state = {
      loading: false,
      loadingStartedAt: 0,
      entities: props.view ? props.view.get('entities', List()) : List(),
      header: props.view ? props.view.get('header', List()) : List(),
      footer: props.view ? props.view.get('footer', List()) : List(),
      empty: props.view ? props.view.get('empty', List()) : List()
    };
    return _this;
  }
  _createClass(View, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _view$get, _view$get2;
      var _this$props2 = this.props,
        id = _this$props2.id,
        display = _this$props2.display,
        page = _this$props2.page,
        args = _this$props2.args,
        view = _this$props2.view,
        filters = _this$props2.filters,
        dispatch = _this$props2.dispatch,
        displayInitialLoadingState = _this$props2.displayInitialLoadingState;
      if (displayInitialLoadingState) {
        this.setState({
          loading: true,
          loadingStartedAt: new Date()
        });
      }

      /**
       * Be ware that comparison with JSON.stringify does not account for different orders in the arrays and objects.
       * Eventhough those would technically yield the same results.
       * Could be optimised later.
       */
      var updatedArgs = JSON.stringify((view === null || view === void 0 ? void 0 : (_view$get = view.get('args')) === null || _view$get === void 0 ? void 0 : _view$get.toJS()) || []) !== JSON.stringify(args === null || args === void 0 ? void 0 : args.map(String));
      var updatedFilters = JSON.stringify((view === null || view === void 0 ? void 0 : (_view$get2 = view.get('filters')) === null || _view$get2 === void 0 ? void 0 : _view$get2.toJS()) || {}) !== JSON.stringify(filters);
      if (id && display && (!view || updatedArgs || updatedFilters)) {
        dispatch(viewGet(id, display, page, args, filters));
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;
      var _this$props3 = this.props,
        id = _this$props3.id,
        display = _this$props3.display,
        view = _this$props3.view,
        args = _this$props3.args,
        filters = _this$props3.filters,
        currentLanguage = _this$props3.currentLanguage,
        dispatch = _this$props3.dispatch;
      var page = this.props.page;
      var loadingStartedAt = this.state.loadingStartedAt;
      // If we change something to the filters than reset the page number.
      if (JSON.stringify(prevProps.filters) !== JSON.stringify(filters)) {
        page = 0;
      }
      var shouldUpdate = prevProps.id !== id || prevProps.display !== display || prevProps.page !== page || prevProps.args.length !== args.length || prevProps.args[0] !== args[0] || JSON.stringify(prevProps.filters) !== JSON.stringify(filters) || prevProps.currentLanguage !== currentLanguage;
      if (shouldUpdate) {
        this.setState({
          loading: true,
          loadingStartedAt: new Date()
        });

        // When the view needs an update, it is most likely due to filters or pagination.
        // Make sure to replace the content, and set referenceLoading to false to prevent
        // a page loading state.
        dispatch(viewGet(id, display, page, args, filters, VIEW_ACTION_REPLACE, false));
      }
      if (prevProps.view && view && prevProps.view !== view) {
        // Our view got updated, so merge it to our internal state.

        // Update the view with a timeout to show the user at least an X amount
        // of seconds of the loading animation to indicate a loading process.

        // NOTE: Only do the above when the actual request took longer than the
        // X amount of seconds. If not, we want to calculate the minimum amount
        // of time to wait for the animation to have been shown once.
        var minimumTimeout = 1666;
        var loadingTime = new Date() - loadingStartedAt;
        var loadingTimeout = loadingTime >= minimumTimeout ? 0 : minimumTimeout - loadingTime;
        this.timeouts.push(setTimeout(function () {
          _this2.setState({
            loading: false,
            entities: view.get('entities', List()),
            header: view.get('header', List()),
            footer: view.get('footer', List()),
            empty: view.get('empty', List())
          });
        }, loadingTimeout));
      } else if (!prevProps.view && view) {
        // This is our initial call where we receive our view for the first time.
        this.setState({
          loading: false,
          entities: view.get('entities', List()),
          header: view.get('header', List()),
          footer: view.get('footer', List()),
          empty: view.get('empty', List())
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props4 = this.props,
        resetStateOnUnmount = _this$props4.resetStateOnUnmount,
        id = _this$props4.id,
        display = _this$props4.display;
      for (var i = 0, len = this.timeouts.length; i < len; i++) {
        clearTimeout(this.timeouts[i]);
      }
      if (resetStateOnUnmount) {
        this.props.dispatch(viewGetLoaded(id, display, null, VIEW_ACTION_REPLACE));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props5 = this.props,
        view = _this$props5.view,
        id = _this$props5.id,
        display = _this$props5.display,
        args = _this$props5.args,
        filters = _this$props5.filters,
        className = _this$props5.className,
        props = _objectWithoutProperties(_this$props5, _excluded);
      var _this$state = this.state,
        loading = _this$state.loading,
        entities = _this$state.entities,
        header = _this$state.header,
        footer = _this$state.footer,
        empty = _this$state.empty;
      if (!view) {
        return null;
      }
      var viewMode = view.get('viewMode');
      var views_block_id = "views_block__".concat(id, "_").concat(display);
      var pager = view.get('pager', Map());
      var classes = classNames('View', className);
      return /*#__PURE__*/React.createElement(EntityMapperContext.Consumer, null, function (entityTypesMapper) {
        var viewMappers = entityTypesMapper.view;
        var ViewComponent = viewMappers[views_block_id];
        if (ViewComponent) {
          return /*#__PURE__*/React.createElement("div", {
            className: classes,
            "view-block-id": views_block_id
          }, /*#__PURE__*/React.createElement(ViewComponent, _extends({}, props, {
            pager: pager,
            entities: entities,
            header: header,
            footer: footer,
            empty: empty,
            viewId: id,
            display: display,
            viewMode: viewMode,
            onLoadMore: _this3.onLoadMore,
            loading: loading,
            args: args,
            filters: filters
          })));
        }
        return /*#__PURE__*/React.createElement("div", null, "No view found: ", views_block_id);
      });
    }
  }]);
  return View;
}(Component);
function ViewFilterQueryProviderHelper(_ref) {
  var children = _ref.children;
  var _useViewFilterQuery = useViewFilterQuery(),
    page = _useViewFilterQuery.page,
    filters = _useViewFilterQuery.filters;
  return children({
    page: page,
    filters: filters
  });
}
function withViewFilterQuery(Component) {
  return function (props) {
    var withProvider = props.withProvider,
      storageType = props.storageType,
      pageQueryParam = props.pageQueryParam,
      passthroughProps = _objectWithoutProperties(props, _excluded2);
    if (withProvider) {
      return /*#__PURE__*/React.createElement(ViewFilterQueryProvider, {
        storageType: storageType,
        pageParam: pageQueryParam
      }, /*#__PURE__*/React.createElement(ViewFilterQueryProviderHelper, null, function (_ref2) {
        var page = _ref2.page,
          filters = _ref2.filters;
        return /*#__PURE__*/React.createElement(Component, _extends({}, passthroughProps, {
          page: page,
          filters: filters
        }));
      }));
    }
    return /*#__PURE__*/React.createElement(Component, passthroughProps);
  };
}
View.defaultProps = {
  page: null,
  args: [],
  filters: {},
  // Backwards compatible.
  resetStateOnUnmount: false,
  // Backwards compatible.
  displayInitialLoadingState: false
};
View.propTypes = {
  id: PropTypes.string.isRequired,
  display: PropTypes.string.isRequired,
  page: PropTypes.number,
  filters: PropTypes.object,
  args: PropTypes.array,
  /**
   * Use this to clear the state after unmounting, e.g. to
   * prevent old state from being displayed on subsequent pages.
   */
  resetStateOnUnmount: PropTypes.bool,
  /**
   * Indicated whether or not we want the initial loading state
   * to be displayed, i.e. on initial render.
   */
  displayInitialLoadingState: PropTypes.bool
};
function mapStateToProps(state, ownProps) {
  return {
    id: ownProps.id,
    display: ownProps.display,
    page: ownProps.page,
    filters: ownProps.filters,
    args: ownProps.args,
    resetStateOnUnmount: ownProps.resetStateOnUnmount,
    view: state.getIn(['view', ownProps.id, ownProps.display]),
    currentLanguage: state.getIn(['ui', 'language'])
  };
}
export default connect(mapStateToProps)(withViewFilterQuery(View));